// Modal: cambiar estado manualmente (dejar enfriar, pausar, reactivar).
import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ESTADO_LABEL = {
  sin_tocar:           "Sin tocar",
  esperando_respuesta: "Esperando respuesta",
  frio:                "Frío",
  en_dialogo:          "En diálogo",
  en_pausa:            "En pausa",
};

const ProspeccionCambioEstadoModal = ({ prospectoId, estadoActual, nuevoEstado, userId, onClose, onSaved }) => {
  const [motivo, setMotivo] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("prospecto_id", prospectoId);
      fd.append("nuevo_estado", nuevoEstado);
      if (motivo) fd.append("motivo", motivo);
      if (userId) fd.append("usuario_id", userId);
      const r = await axios.post(`${BASE}/prospectos_cambiar_estado.php`, fd);
      if (r.data?.success) {
        toast.success(`Estado: ${ESTADO_LABEL[nuevoEstado]}`);
        if (onSaved) onSaved(r.data);
      } else {
        toast.error(r.data?.mensaje || "Error al cambiar estado");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 700, color: "#9f0059" }}>
          Cambiar estado
        </h2>
        <p style={{ margin: "0 0 16px", color: "#666", fontSize: 13 }}>
          De <strong>{ESTADO_LABEL[estadoActual] || estadoActual}</strong> a <strong>{ESTADO_LABEL[nuevoEstado] || nuevoEstado}</strong>.
        </p>
        <form onSubmit={handleSubmit}>
          <Field label="Motivo / nota (opcional)">
            <textarea style={{ ...inp, minHeight: 60, fontFamily: "inherit", resize: "vertical" }} autoFocus
              value={motivo} onChange={(e) => setMotivo(e.target.value)}
              placeholder="Ej: no respondieron tras 3 toques · queda en pausa hasta sep" />
          </Field>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>{submitting ? "Cambiando…" : "Confirmar"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal   = { background: "#fff", borderRadius: 14, padding: 24, maxWidth: 480, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp     = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary   = { padding: "9px 22px", background: "#9f0059", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "9px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

export default ProspeccionCambioEstadoModal;
